import React from "react";
import { connect } from "react-redux";

function Dashboard(props: {connected: boolean}) {

    return (<div>Tableau de Bord</div>);
}
export default connect()(Dashboard);
